module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sign-up":"Sign Up","login":"Login","pricing":"Pricing","blog":"Blog"},"pt-br":{"sign-up":"Cadastrar","login":"Entrar","pricing":"Preços","blog":"Blog"}}')
  delete Component.options._Ctor
}
